import HM5 from "./devices/HM5.png";
import Imagyst from "./devices/Imagyst.png";
import QuickVet from "./devices/QuickVet.png";
import SAUA from "./devices/SAUA.png";
import VetscanSA from "./devices/VetscanSA.png";
import VetscanUA from "./devices/VetscanUA.png";
import VS2 from "./devices/VS2.png";
import VSPro from "./devices/VSPro.png";
import VueAndroid from "./devices/VueAndroid.png";
import VueiOS from "./devices/VueiOS.png";
import iStat from "./devices/iStat.png";
import Unknown from "./devices/Unknown.png";
import HMPLUS from "./devices/HMPLUS.png";

export const images = {
  devices: {
    HM5: HM5,
    Imagyst: Imagyst,
    QuickVet: QuickVet,
    SAUA: SAUA,
    VetscanSA: VetscanSA,
    VetscanUA: VetscanUA,
    VS2: VS2,
    VSPro: VSPro,
    VueAndroid: VueAndroid,
    VueiOS: VueiOS,
    iStat: iStat,
    HMPLUS: HMPLUS,
    Unknown: Unknown,
  },
};
